import React from 'react';

import Modal from 'react-bootstrap/Modal';

import "./editModal.css"


function EditModal({
  show,
  onClose,
  title,
  children,
  size,
  fullscreen,
  scrollable = true,
  dialogClassName,
  bodyClassName,
}) {
    return (
      <Modal
        show={show}
        onHide={onClose}
        centered
        size={size}
        fullscreen={fullscreen}
        scrollable={scrollable}
        dialogClassName={dialogClassName}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={bodyClassName}>{children}</Modal.Body>
      </Modal>
    );
};

export default EditModal;
